import { render, staticRenderFns } from "./SelfModal.vue?vue&type=template&id=c0a4c36a&scoped=true&"
import script from "./SelfModal.vue?vue&type=script&lang=js&"
export * from "./SelfModal.vue?vue&type=script&lang=js&"
import style0 from "./SelfModal.vue?vue&type=style&index=0&id=c0a4c36a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a4c36a",
  null
  
)

export default component.exports